"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalAdapter = void 0;
var axios_1 = __importDefault(require("axios"));
var Utility_1 = require("./Utility");
var systems_sdk_1 = require("@nsftx/systems-sdk");
var Registry_1 = require("./Registry");
var LocalAdapter = /** @class */ (function () {
    function LocalAdapter() {
        this.dmSendAppHeartbeat = false;
        this.dmUsr = 'seven-app@device-management';
        this.dmPwd = 'T49xDGfsP@H@B7D^y^aKkgpU8K&*!v6s';
        this.envPwds = {
            dev: 'T49xDGfsP@H@B7D^y^aKkgpU8K&*!v6s',
            staging: 'T49xDGfsP@H@B7D^y^aKkgpU8K&*!v6s',
            production: 'YZtpWbHHF&$jf!ukt8pMWn9#SAV6E^MV',
        };
    }
    LocalAdapter.prototype.getEndpoint = function (useMock, isConfig) {
        if (isConfig === void 0) { isConfig = false; }
        var base = 'http://127.0.0.1';
        var path = isConfig ? ':8082/get_app_config' : ':8081';
        if (useMock) {
            base = 'http://127.0.0.1:9000/';
            path = isConfig ? 'localAdapterConfig.json' : 'localAdapterDevice.json';
        }
        return "".concat(base).concat(path);
    };
    /**
     * CAUTION: This method respects both standard and CF platform endpoints
     * E.g. https://services-ro2.7platform.com vs https://menhir.ro-2.nsoftcdn.com
     * It also has whitelisted options for DCs different but London/GB
     * If something changed in the future, check this to handle it properly
     *
     */
    LocalAdapter.prototype.getPlatformDataCenter = function (platformUrl) {
        var domain = new URL(platformUrl).hostname;
        var dc = domain.match(/[-.]([a-zA-Z0-9-]+)\./);
        var dcParsed = (dc && dc[1].replace(/[^a-zA-Z0-9]/g, '')) || ''; // E.g. ro-2 => ro2
        var dcWhitelist = ['de', 'ro', 'ro2', 'rs', 'rs2'];
        if (dcWhitelist.includes(dcParsed)) {
            return dcParsed;
        }
        // Consider returning here 'gb' or something else for the default DC
        return undefined;
    };
    /**
     * Application Runtime returns `environment` property as `dc-${dcShortName}`
     * So it has to be replaced with `production` if not dev/staging
     */
    LocalAdapter.prototype.getEnvironment = function (environment) {
        return ['staging', 'dev'].indexOf(environment) < 0 ? 'production' : environment;
    };
    LocalAdapter.prototype.getDeviceResponse = function (useMock) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.getEndpoint(useMock);
                        return [4 /*yield*/, axios_1.default.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    LocalAdapter.prototype.getConfigResponse = function (appVersionName, useMock) {
        return __awaiter(this, void 0, void 0, function () {
            var response, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.getEndpoint(useMock, true);
                        if (!useMock) return [3 /*break*/, 2];
                        return [4 /*yield*/, axios_1.default.get(url)];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, axios_1.default.post(url, JSON.stringify({
                            windowTitle: appVersionName,
                        }), {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, response];
                }
            });
        });
    };
    LocalAdapter.prototype.initDeviceManagement = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.dmCore = new systems_sdk_1.Core(_this.dmAppName);
                        _this.dmCore.connect();
                        _this.dmCore.on('connection', function () { return __awaiter(_this, void 0, void 0, function () {
                            var response;
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4 /*yield*/, ((_a = this.dmCore) === null || _a === void 0 ? void 0 : _a.deviceState())];
                                    case 1:
                                        response = _b.sent();
                                        if (this.dmCore) {
                                            this.dmDisplay = new systems_sdk_1.Display(this.dmCore);
                                            if (this.dmSendAppHeartbeat) {
                                                this.sendDMAppHeartbetInterval();
                                            }
                                        }
                                        resolve(response);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                    })];
            });
        });
    };
    LocalAdapter.prototype.getDMAppRunUuid = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.dmCore && this.dmDisplay) {
                    return [2 /*return*/, this.dmCore.getDisplayApplication().then(function (response) {
                            if (!response || !response.displays) {
                                return null;
                            }
                            console.log('[CONFIG_SERVICE] new DM: Core.getDisplayApplication', response);
                            for (var i = 0; i < response.displays.length; i++) {
                                for (var j = 0; j < response.displays[i].applications.length; j++) {
                                    var displayApp = response.displays[i].applications[j];
                                    var appName = displayApp.application_name;
                                    var appUuid = displayApp.application_uuid;
                                    var productFqn = _this.dmProductFqn.split(' ')[0];
                                    if (appName && appName.toLowerCase().includes(productFqn.toLowerCase()) && appUuid) {
                                        _this.dmAppRunUuid = appUuid;
                                        _this.sendDMAppHeartbetInterval();
                                        return true;
                                    }
                                }
                            }
                        })];
                }
                return [2 /*return*/];
            });
        });
    };
    LocalAdapter.prototype.getDMAppConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var getApplication;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        getApplication = function () { return __awaiter(_this, void 0, void 0, function () {
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(this.dmAppRunUuid && this.dmDisplay)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this.dmDisplay.getApplication(this.dmAppRunUuid).then(function (response) {
                                                var obj = JSON.parse(response);
                                                var appConfig = axios_1.default.get(obj.config_url, {
                                                    auth: {
                                                        username: _this.dmUsr,
                                                        password: _this.dmPwd,
                                                    },
                                                });
                                                return appConfig;
                                            })];
                                    case 1: return [2 /*return*/, _a.sent()];
                                    case 2:
                                        console.warn("[CONFIG_SERVICE] new DM: there is no appRunUuid available for ".concat(this.dmProductFqn, " app!"));
                                        _a.label = 3;
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); };
                        if (!this.dmAppRunUuid) return [3 /*break*/, 1];
                        return [2 /*return*/, getApplication()];
                    case 1: return [4 /*yield*/, this.getDMAppRunUuid().then(function () {
                            return getApplication();
                        })];
                    case 2: 
                    // The appRunUuid should be provided by app runtime, and if not, try to find it
                    return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LocalAdapter.prototype.sendDMAppHeartbetInterval = function () {
        var _this = this;
        if (!(0, Utility_1.isNil)(this.dmAppRunUuid)) {
            clearInterval(this.dmSendAppHeartbeatInterval);
            this.dmSendAppHeartbeatInterval = setInterval(function () {
                var _a;
                (_a = _this.dmDisplay) === null || _a === void 0 ? void 0 : _a.sendAppHeartbeatInterval(_this.dmAppRunUuid);
            }, 15000);
            console.log('[CONFIG_SERVICE] new DM: sendAppHeartbeatInterval activated', this.dmAppRunUuid);
        }
    };
    LocalAdapter.prototype.parseResponse = function (deviceResult, configResult) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var localConfig = (0, Utility_1.defaultTo)(configResult.appConfig, configResult.app_config);
        return {
            environment: this.getEnvironment(configResult.environment),
            platformName: Registry_1.registry.platforms.seven.name,
            platformDataCenter: this.getPlatformDataCenter((0, Utility_1.defaultTo)(configResult === null || configResult === void 0 ? void 0 : configResult.sevenUrl, configResult === null || configResult === void 0 ? void 0 : configResult.seven_url)),
            productId: (0, Utility_1.defaultTo)((_a = configResult === null || configResult === void 0 ? void 0 : configResult.cpvUuids) === null || _a === void 0 ? void 0 : _a[0], (_b = configResult === null || configResult === void 0 ? void 0 : configResult.cpv_uuids) === null || _b === void 0 ? void 0 : _b[0]),
            tenantId: (0, Utility_1.defaultTo)((_c = deviceResult === null || deviceResult === void 0 ? void 0 : deviceResult.betshop) === null || _c === void 0 ? void 0 : _c.companyUuid, (_d = deviceResult === null || deviceResult === void 0 ? void 0 : deviceResult.space) === null || _d === void 0 ? void 0 : _d.uuid),
            locale: localConfig.language,
            messageProtocol: Registry_1.registry.messageProtocols.postMessage.name,
            channelId: (0, Utility_1.defaultTo)((_e = deviceResult === null || deviceResult === void 0 ? void 0 : deviceResult.device) === null || _e === void 0 ? void 0 : _e.type, (_f = deviceResult === null || deviceResult === void 0 ? void 0 : deviceResult.device) === null || _f === void 0 ? void 0 : _f.device_type),
            betshopId: (0, Utility_1.defaultTo)((_g = deviceResult === null || deviceResult === void 0 ? void 0 : deviceResult.betshop) === null || _g === void 0 ? void 0 : _g.uuid, (_h = deviceResult === null || deviceResult === void 0 ? void 0 : deviceResult.location) === null || _h === void 0 ? void 0 : _h.uuid),
            deviceId: deviceResult.device.uuid,
            isIntegration: false,
            localConfig: {
                ajsType: (0, Utility_1.defaultTo)(localConfig === null || localConfig === void 0 ? void 0 : localConfig.ajs, localConfig === null || localConfig === void 0 ? void 0 : localConfig.ajsType),
                applicationName: (0, Utility_1.defaultTo)(configResult === null || configResult === void 0 ? void 0 : configResult.name, configResult === null || configResult === void 0 ? void 0 : configResult.application_name),
                aspectRatio: (0, Utility_1.defaultTo)(configResult === null || configResult === void 0 ? void 0 : configResult.aspectRatio, configResult === null || configResult === void 0 ? void 0 : configResult.aspect_ratio),
                displayId: configResult.display_id,
                displayOutput: configResult.display_output,
                resolution: configResult.resolution,
                quality: localConfig.quality,
                animationSet: localConfig.animationSet,
                sound: (0, Utility_1.defaultTo)(localConfig === null || localConfig === void 0 ? void 0 : localConfig.sound, localConfig === null || localConfig === void 0 ? void 0 : localConfig.soundEnabled),
                rawData: localConfig,
            },
        };
    };
    LocalAdapter.prototype.getConfiguration = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var env, _a, deviceResponse, configResponse, deviceResult, configResult;
            var _this = this;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!options.useSystemsSdk) return [3 /*break*/, 1];
                        this.dmProductFqn = (_b = Registry_1.registry.getProduct(options.productName || '')) === null || _b === void 0 ? void 0 : _b.fqn;
                        this.dmAppName = (0, Utility_1.defaultTo)(options.includeLocalAdapter, '');
                        if (options.appRunUuid) {
                            this.dmAppRunUuid = options.appRunUuid;
                        }
                        if (options.sendAppHeartbeat) {
                            this.dmSendAppHeartbeat = options.sendAppHeartbeat;
                        }
                        if (options.environment) {
                            env = this.getEnvironment(options.environment);
                            this.dmPwd = this.envPwds[env];
                        }
                        return [2 /*return*/, this.initDeviceManagement().then(function (response) {
                                var deviceResult = response;
                                console.log('[CONFIG_SERVICE] new DM: Core.deviceState', deviceResult);
                                return _this.getDMAppConfig().then(function (response) {
                                    var configResult = (response === null || response === void 0 ? void 0 : response.data) || null;
                                    console.log('[CONFIG_SERVICE] new DM: Display.getApplication', configResult);
                                    if (!(0, Utility_1.isNil)(deviceResult) && !(0, Utility_1.isNil)(configResult)) {
                                        return _this.parseResponse(deviceResult, configResult);
                                    }
                                });
                            })];
                    case 1: return [4 /*yield*/, Promise.all([
                            this.getDeviceResponse((0, Utility_1.defaultTo)(options.useMock, false)),
                            this.getConfigResponse((0, Utility_1.defaultTo)(options.includeLocalAdapter, ''), (0, Utility_1.defaultTo)(options.useMock, false)),
                        ])];
                    case 2:
                        _a = _c.sent(), deviceResponse = _a[0], configResponse = _a[1];
                        deviceResult = deviceResponse ? deviceResponse.data : null;
                        configResult = configResponse ? configResponse.data : null;
                        if (!(0, Utility_1.isNil)(deviceResult) && !(0, Utility_1.isNil)(configResult)) {
                            return [2 /*return*/, this.parseResponse(deviceResult, configResult)];
                        }
                        _c.label = 3;
                    case 3: return [2 /*return*/, {}];
                }
            });
        });
    };
    return LocalAdapter;
}());
exports.LocalAdapter = LocalAdapter;
//# sourceMappingURL=LocalAdapter.js.map